<template>
<div>
    <div class="dekstop-view">
        <div class="tableFixHead sticky2">
            <table>
                <thead class="text-center">
                    <tr>
                        <th class="text-left" style="width:50px;max-width:50px">Nama</th>
                        <th class="text-left" style="width:100px;max-width:100px">Tanggal</th>
                        <th class="text-left" style="width:75px;max-width:75px">Total Pengajuan</th>
                        <th class="text-left" style="width:75px;max-width:75px;">Total Dibayarkan</th>
                        <th class="text-left" style="width:50px;max-width:50px">Progres</th>
                        <th class="text-left" style="width:75px;max-width:75px">Status</th>
                        <th class="text-left" style="width:50px;max-width:50px">Action</th>
                    </tr>
                </thead>
            </table>
        </div>
        <div class="content-sticky">
            <CRow>
                <CCol sm="12">
                    <div class="tableFixHead">
                        <table>
                            <tbody v-if="data.length == 0">
                                <tr>
                                    <td class="text-center" colspan="5">
                                        {{errors}}
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr v-for="(body, id) in data" :key="id">
                                    <td style="width:50px;max-width:50px">Kloter {{body.kloter}}</td>
                                    <td style="width:100px;max-width:100px;padding-left:10px;padding-right:10px;">{{body.tanggal}}</td>
                                    <td style="width:75px;max-width:75px"><span style="float:right">{{separatorRupiah(body.diajukan)}}</span></td>
                                    <td style="width:75px;max-width:75px"><span style="float:right">{{separatorRupiah(body.dibayar)}}</span></td>
                                    <td style="width:50px;max-width:50px">
                                        <span>{{body.progress}}</span>
                                    </td>
                                    <td style="width:75px;max-width:75px" :title="body.keteranganStatus">
                                        <span class="font-weight-bold" :style="{ color : body['color'] }">{{body.keteranganStatus}}</span>
                                    </td>
                                    <td style="width:50px;max-width:50px">
                                        <div class="text-center">
                                            <CButton v-if="body.status == 'W'" @click="goEdit(id)" class="btn btn-edit">Action</CButton>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </CCol>
            </CRow>
        </div>
    </div>
    <div class="mobile-view">
        <CRow class="mt-3">
            <CCol sm="12">
                <div>
                    <table class="table-responsive">
                        <thead class="text-center">
                            <tr>
                                <th class="text-left">Nama</th>
                                <th class="text-left">Tanggal</th>
                                <th class="text-left">Total Pengajuan</th>
                                <th class="text-left">Total Dibayarkan</th>
                                <th class="text-left">Progres</th>
                                <th class="text-left">Status</th>
                                <th class="text-left">Action</th>
                            </tr>
                        </thead>
                        <tbody v-if="data.length == 0">
                            <tr>
                                <td class="text-center" colspan="5">
                                    {{errors}}
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr v-for="(body, id) in data" :key="id">
                                <td>Kloter {{body.kloter}}</td>
                                <td style="padding-left:10px;padding-right:10px;">{{body.tanggal}}</td>
                                <td><span style="float:right">{{separatorRupiah(body.diajukan)}}</span></td>
                                <td><span style="float:right">{{separatorRupiah(body.dibayar)}}</span></td>
                                <td>
                                    <span>{{body.progress}}</span>
                                </td>
                                <td :title="body.keteranganStatus">
                                    <span class="font-weight-bold" :style="{ color : body['color'] }">{{body.keteranganStatus}}</span>
                                </td>
                                <td>
                                    <div class="text-center">
                                        <CButton v-if="body.status == 'W'" @click="goEdit(id)" class="btn btn-edit">Action</CButton>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </CCol>
        </CRow>
    </div>
</div>
</template>

<script>
export default {
    props: ['data', 'errors'],
    data() {
        return {
            sortIcon: [],
            photo: require('@/assets/image/images.svg'),
            closeIcon: require('@/assets/menu/icon_close.svg'),
            downloadIcon: require('@/assets/menu/icon_download_excel.svg'),
        }
    },
    mounted() {
    },
    watch: {

    },
    methods: {
        goEdit(id) {
            this.$emit('edit', id)
        },
        separatorRupiah(val) {
            if(val == 'null') {
                val = '0'
            }
            let leng = val.length
            let sisa 	= leng % 3
            let rupiah 	= val.substr(0, sisa)
            let ribuan 	= val.substr(sisa).match(/\d{3}/g)
                
            if (ribuan) {
                let separator = sisa ? '.' : ''
                rupiah += separator + ribuan.join('.')
            }
            return 'Rp. ' + rupiah 
        },    
    },
}
</script>

<style scoped>
@media only screen and (max-width:1278px) {
  .dekstop-view {
      display: none;
  }
}
@media only screen and (min-width:1279px) {
  .mobile-view {
      display: none;
  }
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 16px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 16px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 20px;
    padding-right: 20px;
}
td,th {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
div.sticky2 {
    position: -webkit-sticky;
    position: sticky;
    top: 105px;
    background-color: white;
    z-index: 1;
}
.content-sticky {
    background-color: white;
}
.btn-edit {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: white;
    color: black;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
}
.btn-edit:hover {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: rgba(154, 154, 154, 1);
    color: white;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
}
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
.modal-buttons {
    width:156px;
    height: 36px;
}
.modal-button-cancel {
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: white;
    color: rgba(16, 16, 16, 1);
}
.modal-button-cancel:hover {
    border: 1px solid rgba(48, 107, 240, 1);
    background-color: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
</style>
